var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFadedlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 229,
    viewBox: "0 0 245 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.055 163.703L150.909 93.9775L220.67 97.1219L286 162.419L219.385 229L154.055 163.703Z",
    fill: "#EAEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.945 163.703L135.091 93.9775L65.3566 97.1219L0 162.419L66.6149 229L131.945 163.703Z",
    fill: "#EAEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.945 9.29712L135.091 79.0225L65.3566 75.8782L0 10.5811L66.6149 -56L131.945 9.29712Z",
    fill: "#EAEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.055 9.29712L150.909 79.0225L220.67 75.8782L286 10.581L219.385 -56L154.055 9.29712Z",
    fill: "#EAEAF8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFadedlogo);
export default __webpack_public_path__ + "static/media/fadedlogo.7be4cb848ccc3a97eaaeee0d20a1d4f8.svg";
export { ForwardRef as ReactComponent };